import { Button, Flex, Text } from "@theorgchartdev/storybook";
import { GetWSMgr, ReRenderCanvas } from "@/Utils/StateLib";
import { useRightSidebarContext } from "@/providers/RightSidebarProvider";
import { enumOverrideType } from "@coreapp/constants";
import { appstr } from "@coreapp/utils/appstr";
import { GetShortObjLabel, isOrphanChange } from "./ChangeDisplayRow.utils";
import type { QObjDBObject } from "@coreapp/CoreApp/QObjDBObject";
import type { QChange } from "@coreapp/CoreApp/QChange";

interface RecordLinkProps {
  docRef?: any;
  dbObj?: QObjDBObject | null;
  change?: QChange | null;
}

export const RecordLink = ({ docRef, dbObj, change }: RecordLinkProps) => {
  const { handleSideBarModeChange, highlightRecord } = useRightSidebarContext() as any;

  const isRecordOrphaned = isOrphanChange(change);
  const isMoveOut = change?.GetChangeType() === enumOverrideType.moveout || false;

  let label = GetShortObjLabel(dbObj);
  if (!label) {
    label = change?.GetSupervisorLabel();
  }

  if (isRecordOrphaned) {
    label = appstr("Staging");
    if (docRef?.IsPositionDocument()) {
      label = appstr("Unassigned").toLocaleLowerCase();
    }
  }

  const handleClick = () => {
    const wsMgr = GetWSMgr();

    if (isRecordOrphaned) {
      let targetMode = "staging";
      if (docRef?.IsPositionDocument()) {
        targetMode = "employeeList";
      }

      handleSideBarModeChange(targetMode);
      const dbObj = change?.fDBObj;
      if (dbObj) {
        highlightRecord(dbObj);
      }

      return;
    }

    let targetID = dbObj?.GetObjectRecordID();
    if (targetID == null) {
      targetID = change?.GetSupervisorID();
    }

    if (targetID == null || !wsMgr?.fCanvasPanel || typeof wsMgr?.DoNavToBox !== "function") {
      return;
    }

    const canvasPanel = wsMgr.fCanvasPanel;
    canvasPanel.AddToInitialHighlight(targetID);

    wsMgr.DoNavToBox({ targetID }, true);
    ReRenderCanvas();
  };

  return isMoveOut ? (
    <Flex>
      <Text size={"xsmall"}>{label}</Text>
    </Flex>
  ) : (
    <Button modifier={"underline"} size={"xsmall"} onClick={handleClick}>
      {label}
    </Button>
  );
};
